import { useEffect, useRef, useState, useCallback } from 'react'
import { dashboardApi } from '../services/api'

const POLL_MS = 600_000

// TODO: type this
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type MyDaySnapshot = any

export function useDashboardMyDay() {
  const [data, setData] = useState<MyDaySnapshot>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<unknown>(null)
  const timer = useRef<ReturnType<typeof setInterval>>()

  const refresh = useCallback(async () => {
    try { setData(await dashboardApi.myDay()); setError(null) }
    catch (e) { setError(e) }
    finally { setLoading(false) }
  }, [])

  useEffect(() => {
    refresh()
    timer.current = setInterval(() => { if (!document.hidden) refresh() }, POLL_MS)
    return () => clearInterval(timer.current)
  }, [refresh])

  return { data, loading, error, refresh }
}
